import React from "react";
import useShipmentCreateFlow from "../../../../hooks/reduxContainer/fulfillment/shipmentCreateFlow";
import { SelectItem, SelectItemInventoryWarehouseReceiving } from "@secondcloset/web-components";
import { Alert, Space } from "antd";
import { Fulfillment } from "@secondcloset/types";

interface SelectItemsStepProps {
  disablePartialFulfillment: boolean;
  orderItems: Fulfillment.OrderItem<"V2">[];
  shipments: Fulfillment.Shipment<"V2">[];
}

const SelectItemsStep: React.FC<SelectItemsStepProps> = ({ disablePartialFulfillment, orderItems, shipments }) => {
  const {
    order,
    selectedOrderItemIDs,
    returnReasons,
    isEndy,
    isFullRefund,
    isExchange,
    isUnopenedCancellation,
    isReturnWarningVisible,
    isInventoryWarehouseReceiving,
    isPartialDelivery,
    dispatchSetSelectedOrderItemIDs,
    dispatchSetReturnReasons,
    dispatchSetIsFullRefund,
    dispatchSetIsExchange,
    dispatchSetIsUnopenedCancellation,
    dispatchSetIsPartialDelivery,
    isReturn,
  } = useShipmentCreateFlow();

  // TODO add iwr support for v2 get order items endpoint
  if (isInventoryWarehouseReceiving && !isReturn) {
    return (
      <SelectItemInventoryWarehouseReceiving
        order={order}
        selectedOrderItemIDs={selectedOrderItemIDs}
        setSelectedOrderItemIDs={dispatchSetSelectedOrderItemIDs}
      />
    );
  }

  const hasInventoryWarehouseReceiving = shipments?.some((shipment) =>
    shipment?.action_summary?.includes("inventory_warehouse_receiving")
  );

  return (
    <>
      <SelectItem
        order={{ ...order, items: order.items || [] }}
        orderItems={orderItems}
        selectedOrderItemIDs={selectedOrderItemIDs}
        setSelectedOrderItemIDs={dispatchSetSelectedOrderItemIDs}
        isReturn={isReturn}
        returnReasons={returnReasons}
        setReturnReasons={dispatchSetReturnReasons}
        hasInventoryReceivingShipment={hasInventoryWarehouseReceiving}
        isEndy={isEndy}
        isFullRefund={isFullRefund}
        isExchange={isExchange}
        isUnopenedCancellation={isUnopenedCancellation}
        isReturnWarningVisible={isReturnWarningVisible}
        setIsFullRefund={dispatchSetIsFullRefund}
        setIsExchange={dispatchSetIsExchange}
        setIsUnopenedCancellation={dispatchSetIsUnopenedCancellation}
        setIsPartialDelivery={dispatchSetIsPartialDelivery}
      />
      {disablePartialFulfillment && !!selectedOrderItemIDs.length && isPartialDelivery && (
        <Space direction="vertical" align="center" style={{ width: "100%", margin: "24px" }}>
          <Alert
            showIcon
            banner
            type="warning"
            message={`You are attempting to create a partial shipment for ${order.organization.name} which normally does not allow orders to be partially fulfilled`}
          />
        </Space>
      )}
    </>
  );
};

export default SelectItemsStep;
